import React from "react";
import { motion, AnimatePresence } from "framer-motion";

const DeveloperViewModal = ({ isOpen, onClose, developer, loading }) => {
  if (!isOpen) return null;

  const API_BASE = "https://algoritm-api-edu.uz";

  return (
    <AnimatePresence>
      <motion.div
        className="modal-backdrop"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
        onClick={onClose}
      >
        <motion.div
          className="modal-content"
          initial={{ scale: 0.85, y: 60 }}
          animate={{ scale: 1, y: 0 }}
          exit={{ scale: 0.85, y: 60 }}
          onClick={(e) => e.stopPropagation()}
          style={{
            maxWidth: "720px",
            borderRadius: "16px",
            padding: "32px",
            maxHeight: "90vh",
            overflowY: "auto",
          }}
        >
          <h3 style={{ margin: "0 0 28px", fontSize: "24px", fontWeight: 700 }}>
            Dasturchi ma'lumotlari
          </h3>

          {loading ? (
            <div style={{ textAlign: "center", padding: "100px 0" }}>
              Yuklanmoqda...
            </div>
          ) : developer ? (
            <div
              style={{ display: "flex", flexDirection: "column", gap: "24px" }}
            >
              {/* Rasm */}
              {developer.imageUrl && (
                <div style={{ textAlign: "center" }}>
                  <img
                    src={developer.imageUrl}
                    alt={developer.fullName}
                    style={{
                      width: "180px",
                      height: "180px",
                      borderRadius: "50%",
                      objectFit: "cover",
                      border: "4px solid #e0e7ff",
                      boxShadow: "0 4px 16px rgba(0,0,0,0.1)",
                    }}
                    onError={(e) => {
                      e.target.src =
                        "https://via.placeholder.com/180/6366f1/ffffff?text=DEV";
                    }}
                  />
                </div>
              )}

              <div style={{ display: "grid", gap: "16px" }}>
                <div>
                  <strong>Ism Familya:</strong> {developer.fullName || "—"}
                </div>

                <div>
                  <strong>Lavozim:</strong> {developer.position || "—"}
                </div>

                <div>
                  <strong>Telefon:</strong> {developer.phoneNumber || "—"}
                </div>

                {developer.bio && (
                  <div>
                    <strong>Bio / Haqida:</strong>
                    <p
                      style={{
                        marginTop: "8px",
                        whiteSpace: "pre-wrap",
                        lineHeight: 1.6,
                      }}
                    >
                      {developer.bio}
                    </p>
                  </div>
                )}

                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "12px",
                  }}
                >
                  <strong>Ijtimoiy tarmoqlar:</strong>
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      gap: "8px",
                    }}
                  >
                    {developer.gitUrl && (
                      <div>
                        GitHub:{" "}
                        <a
                          href={developer.gitUrl}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          {developer.gitUrl}
                        </a>
                      </div>
                    )}
                    {developer.instagramUrl && (
                      <div>
                        Instagram:{" "}
                        <a
                          href={developer.instagramUrl}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          {developer.instagramUrl}
                        </a>
                      </div>
                    )}
                    {developer.linkedinUrl && (
                      <div>
                        LinkedIn:{" "}
                        <a
                          href={developer.linkedinUrl}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          {developer.linkedinUrl}
                        </a>
                      </div>
                    )}
                    {developer.telegramUsername && (
                      <div>Telegram: @{developer.telegramUsername}</div>
                    )}
                    {!developer.gitUrl &&
                      !developer.instagramUrl &&
                      !developer.linkedinUrl &&
                      !developer.telegramUsername && (
                        <span style={{ color: "#9ca3af" }}>
                          Ijtimoiy tarmoqlar kiritilmagan
                        </span>
                      )}
                  </div>
                </div>

                <div>
                  <strong>ID:</strong>{" "}
                  <span style={{ fontFamily: "monospace", color: "#6b7280" }}>
                    {developer.id}
                  </span>
                </div>
              </div>
            </div>
          ) : (
            <div
              style={{
                textAlign: "center",
                padding: "80px 0",
                color: "#e74c3c",
              }}
            >
              Ma'lumot topilmadi
            </div>
          )}

          <div style={{ marginTop: "32px", textAlign: "right" }}>
            <button
              onClick={onClose}
              style={{
                padding: "10px 28px",
                background: "#f1f5f9",
                border: "none",
                borderRadius: "8px",
                fontWeight: 500,
                cursor: "pointer",
              }}
            >
              Yopish
            </button>
          </div>
        </motion.div>
      </motion.div>
    </AnimatePresence>
  );
};

export default DeveloperViewModal;
